import { faCirclePlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import "./ScopeOfTheLaboratory_Form.css";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import {
  AllMaterialTested,
  AllComponent,
  AllTestMethod,
} from "../../../../../../../features/admin/common/Slice";
import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/structural_requirement/scope_of_laboratoy/Slice";
import { useDispatch, useSelector } from "react-redux";

function ScopeOfTheLaboratory_Form() {
  const defaultValues = {
    discipline: "",
    material_tested_id: null,
    component_id: null,
    test_method_id: null,
    documents: [{ file: null }],
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
    watch,
    getValues,
  } = useForm({
    defaultValues,
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "documents",
  });

  const [showError, setShowError] = useState({});
  const [previews, setPreviews] = useState({});
  const [success, setSuccess] = useState(false);

  const dispatch = useDispatch();
  const all_material_tested = useSelector(
    (state) => state.common.all_material_tested,
  );
  const all_component = useSelector((state) => state.common.all_component);
  const all_test_method = useSelector((state) => state.common.all_test_method);

  useEffect(() => {
    dispatch(AllMaterialTested());
    dispatch(AllComponent());
    dispatch(AllTestMethod());
  }, [dispatch]);

  // 🔹 file change + preview
  const handleFileChange = (file, index) => {
    setValue(`documents.${index}.file`, file);

    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setPreviews((prev) => ({ ...prev, [index]: previewUrl }));
    }
  };

  const handleCancel = () => {
    reset(defaultValues);
    setPreviews({});
  };

  // 🔹 submit
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("discipline", data.discipline);
      formData.append("material_tested_id", data.material_tested_id);
      formData.append("component_id", data.component_id);
      formData.append("test_method_id", data.test_method_id);

      // data.documents.forEach((doc) => {
      //   if (doc.file) {
      //     formData.append("documents", doc.file);
      //   }
      // });

      data.documents.forEach((file, index) => {
        if (file && file.length > 0) {
          formData.append("documents", file[0]);
        }
      });

      const res = await dispatch(Create(formData));
      console.log("res.meta.requestStatus", res.meta.requestStatus);
      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        reset({
          discipline: "",
          material_tested_id: null,
          component_id: null,
          test_method_id: null,
        });

        setValue("material_tested_id", null);
        setValue("component_id", null);
        setValue("test_method_id", null);

        replace([{ file: null }]);
        setPreviews({});
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
      } else {
        setShowError(res.payload.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {/* Discipline */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Discipline/ Group</Form.Label>
                  <Form.Control
                    placeholder="Discipline/ Group"
                    {...register("discipline", {
                      required: "Discipline / Group is required",
                    })}
                  />
                  {errors.discipline && (
                    <small className="text-danger">
                      {errors.discipline.message}
                    </small>
                  )}
                </Form.Group>
              </div>

              {/* Material Tested */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Material Or Products Tested</Form.Label>
                  <Controller
                    name="material_tested_id"
                    control={control}
                    rules={{ required: "Material is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_material_tested}
                        value={
                          all_material_tested?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.material_tested_id && (
                    <Form.Text className="text-danger">
                      {errors.material_tested_id.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>

              {/* Component */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>
                    Component, Parameter Or Characteristic Tested/ Specific Test
                    Performed / Tests Or Type Of Tests Performed
                  </Form.Label>
                  <Controller
                    name="component_id"
                    control={control}
                    rules={{ required: "Component is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_component}
                        value={
                          all_component?.find((o) => o.value === field.value) ||
                          null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.component_id && (
                    <Form.Text className="text-danger">
                      {errors.component_id.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>

              {/* Test Method */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>
                    {" "}
                    Test Method Specification against which tests are performed
                    and/or the techniques/equipment used
                  </Form.Label>
                  <Controller
                    name="test_method_id"
                    control={control}
                    rules={{ required: "Test method is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_test_method}
                        value={
                          all_test_method?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.test_method_id && (
                    <Form.Text className="text-danger">
                      {errors.test_method_id.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>

              {/* Documents */}
              {fields.map((item, index) => {
                const fileValue = watch(`documents.${index}`);

                // URL for preview
                const fileUrl =
                  typeof fileValue === "string"
                    ? process.env.REACT_APP_IMG_URL + fileValue
                    : fileValue?.[0]
                    ? URL.createObjectURL(fileValue[0])
                    : null;

                // Type detection
                const fileType =
                  typeof fileValue === "string"
                    ? fileValue.toLowerCase()
                    : fileValue?.[0]?.type;

                return (
                  <div className="col-md-6" key={item.id}>
                    <Form.Group className="form_group file_field">
                      <Form.Label>Attach Scope Of The Laboratory Document</Form.Label>

                      <div className="absolute_fields">
                        {/* <Form.Control value="Upload File" disabled /> */}

                        {/* <label className="upload_icon_holder">
                          <FontAwesomeIcon
                            icon={faUpload}
                            className="upload_icon"
                          /> */}

                        <Form.Control
                          type="file"
                          {...register(`documents.${index}`, {
                            validate: (value) => {
                              if (typeof value === "string" && value)
                                return true;

                              if (value && value.length > 0) return true;

                              return "File is required";
                            },
                          })}
                          accept="*"
                        />
                        {errors?.documents?.[index] && (
                          <p className="text-danger">
                            {errors.documents[index].message}
                          </p>
                        )}
                      </div>

                      {/* Preview Section */}
                      {fileUrl && (
                        <div className="image_holder mt-2">
                          {/* IMAGE */}
                          {(fileType?.includes("image") ||
                            fileType?.endsWith(".jpg") ||
                            fileType?.endsWith(".jpeg") ||
                            fileType?.endsWith(".png")) && (
                            <img
                              src={fileUrl}
                              alt="Preview"
                              style={{ maxWidth: "150px" }}
                            />
                          )}

                          {/* PDF */}
                          {(fileType === "application/pdf" ||
                            fileType?.endsWith(".pdf")) && (
                            <iframe
                              src={fileUrl}
                              title="PDF Preview"
                              style={{ width: "100%", height: "150px" }}
                            />
                          )}

                          {/* WORD */}
                          {(fileType?.includes("word") ||
                            fileType?.endsWith(".doc") ||
                            fileType?.endsWith(".docx")) && (
                            <div>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open Word File
                              </a>

                              <iframe
                                src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                                style={{ width: "100%", height: "150px" }}
                                title="Word Preview"
                              />
                            </div>
                          )}

                          {/* EXCEL */}
                          {(fileType?.includes("spreadsheet") ||
                            fileType?.endsWith(".xlsx") ||
                            fileType?.endsWith(".xls")) && (
                            <div>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open Excel File
                              </a>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Remove Button */}
                      {index > 0 && (
                        <Button
                          type="button"
                          className="mt-2"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </Button>
                      )}
                    </Form.Group>
                  </div>
                );
              })}
              {/* {fields.map((item, index) => (
                <div className="col-md-6" key={item.id}>
                  <Form.Group className="form_group file_field">
                    <Form.Label>Attach Scope Document</Form.Label>

                    <div className="absolute_fields">
                      <Form.Control value="Upload File" disabled />
                      <label className="upload_icon_holder">
                        <FontAwesomeIcon
                          icon={faUpload}
                          className="upload_icon"
                        />
                        <input
                          type="file"
                          hidden
                          onChange={(e) =>
                            handleFileChange(e.target.files[0], index)
                          }
                        />
                      </label>
                    </div>

                    <div className="image_holder">
                      <img
                        className="img_preview"
                        src={
                          previews[index] ||
                          "/assets/images/other/dummy-image.png"
                        }
                      />
                    </div>

                    {index > 0 && (
                      <Button
                        type="button"
                        className="mt-2"
                        onClick={() => remove(index)}
                      >
                        Remove
                      </Button>
                    )}
                  </Form.Group>
                </div>
              ))} */}

              {/* Add Another */}
              <div className="col-12">
                <div
                  className="add_another_holder"
                  onClick={() => append({ file: null })}
                >
                  <span>
                    <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
                  </span>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="permission_btn_holder">
              {success ? (
                <Success_Toster successText="Saved Successfully!" />
              ) : (
                <>
                  <Button
                    type="button"
                    className="permission_btn No_btn"
                    onClick={handleCancel}
                  >
                    Reset
                  </Button>
                  <Button type="submit" className="permission_btn Yes_btn">
                    Save
                  </Button>
                </>
              )}
            </div>
          </Form>
        </div>
      </section>
    </>
  );
}

export default ScopeOfTheLaboratory_Form;
